import { request } from './shared';

export function reportInputError(rawInput, errorType, message) {
  return request({
    data: {
      input:       rawInput,
      error_type:  errorType,
      message:     message,
    },
    method: 'POST',
    url:    '/report-input-error',
  });
}